import React, { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';

const styles = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0b0f14, #0a0a0c)",
    color: "#e7e7e9",
    padding: "48px 16px 72px",
    fontFamily: "'Pretendard', 'Noto Sans KR', system-ui, -apple-system, sans-serif",
    boxSizing: "border-box",
  },
  container: {
    maxWidth: "640px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  card: {
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.07)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.32)",
    borderRadius: "18px",
    padding: "24px 20px",
  },
  title: {
    margin: "0 0 6px",
    fontSize: "26px",
    fontWeight: 800,
    color: "#fff",
    letterSpacing: "-0.02em",
  },
  helper: {
    color: "#cbd5e1",
    fontSize: "13px",
    marginBottom: "12px",
    lineHeight: 1.5,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  field: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    fontWeight: 700,
    color: "#f8fafc",
    fontSize: "14px",
  },
  inputWrap: {
    position: "relative",
  },
  input: {
    width: "100%",
    padding: "12px 14px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(255,255,255,0.05)",
    color: "#f8fafc",
    fontSize: "15px",
    boxSizing: "border-box",
  },
  toggleBtn: {
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.12)",
    color: "#f8fafc",
    borderRadius: "10px",
    padding: "4px 10px",
    cursor: "pointer",
    fontSize: "14px",
  },
  error: {
    color: "#fca5a5",
    fontSize: "12px",
  },
  submitRow: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "4px",
  },
  submitBtn: {
    padding: "14px 16px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "linear-gradient(120deg, #fb923c, #f97316)",
    color: "#130903",
    fontWeight: 800,
    cursor: "pointer",
    boxShadow: "0 12px 28px rgba(249,115,22,0.26)",
    minWidth: "120px",
  },
  submitBtnDisabled: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
  linksRow: {
    display: "flex",
    gap: "14px",
    marginTop: "10px",
  },
  link: {
    color: "#fb923c",
    fontWeight: 700,
    textDecoration: "none",
    fontSize: "14px",
  },
  popup: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    background: "rgba(15,10,8,0.9)",
    color: "#f8fafc",
    padding: "12px 14px",
    borderRadius: "12px",
    border: "1px solid rgba(255,255,255,0.12)",
    boxShadow: "0 16px 32px rgba(0,0,0,0.35)",
    maxWidth: "280px",
    zIndex: 1000,
    fontSize: "14px",
  },
};

const autofillStyles = `
.login-input {
  background: rgba(15,15,20,0.9) !important;
  color: #f8fafc !important;
  border: 1px solid rgba(255,255,255,0.14) !important;
  border-radius: 12px;
  padding: 12px 14px;
  box-sizing: border-box;
  transition: outline-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}
.login-input::placeholder {
  color: #94a3b8;
}
.login-input:focus {
  outline: 2px solid rgba(249,115,22,0.45) !important;
  border-color: rgba(249,115,22,0.45) !important;
  box-shadow: 0 0 0 1000px rgba(15,15,20,0.95) inset !important;
}
.login-input:-webkit-autofill,
.login-input:-webkit-autofill:hover,
.login-input:-webkit-autofill:focus,
.login-input:-webkit-autofill:active {
  background: rgba(15,15,20,0.95) !important;
  -webkit-text-fill-color: #f8fafc !important;
  box-shadow: 0 0 0 1000px rgba(15,15,20,0.95) inset !important;
  caret-color: #f8fafc;
  border: 1px solid rgba(255,255,255,0.14) !important;
}
`;

export default function Login(){

    const[email,setEmail] = useState('');
    const[pw,setPw] = useState('');

    const[emailValid, setEmailValid] = useState(false);
    const[pwValid, setPwValid] = useState(false);
    const[notAllow, setNotAllow] = useState(true);

    const [showMessage, setShowMessage] = useState(false);
    const [showPassword, setShowPassword] = useState(false); // 비밀번호 보이기 토글 상태
    const [showConfirmPassword, setShowConfirmPassword] = useState(false); // 비밀번호 보이기 토글 상태
    const [confirmMessage, setConfirmMessage] = useState('');

    const [cookies, setCookie] = useCookies(['uuid']);

    useEffect(() => {
      // 여기에 통신 요청이 완료되면 알림 메시지를 자동으로 사라지게 하는 로직을 추가하세요.
      const timer = setTimeout(() => {
        setShowMessage(false);
      }, 3000); // 5초 후에 알림 메시지를 숨김
      return () => clearTimeout(timer); // 컴포넌트가 언마운트되면 타이머 해제
    }, [showMessage]); 

    const handleEmail = (e) => {
      const newEmail = e.target.value.trim();
      setEmail(newEmail);
      const regex = 
      /^(([^<>()\[\].,;:\s@"]+(\.[^<>()\[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
      if (regex.test(newEmail)) {
          setEmailValid(true);
        } 
      else {
          setEmailValid(false);
        }
      };
        
    const handlePw = (e) => {
      const newPw = e.target.value.trim();
      setPw(newPw);
        const regex =
          /^(?=.*[a-zA-z])(?=.*[0-9])(?=.*[$`~!@$!%*#^?&\\(\\)\-_=+])(?!.*[^a-zA-z0-9$`~!@$!%*#^?&\\(\\)\-_=+]).{8,20}$/;
        if (regex.test(newPw)) {
          setPwValid(true);
        } 
      else {
          setPwValid(false);
        }
      };
    
    useEffect(() => {
        if(emailValid && pwValid) {
          setNotAllow(false);
          return;
        }
        setNotAllow(true);
      }, [emailValid, pwValid]);

    const onClickConfirmButton = () => {
      const loginData = {
        email: email,
        password: pw
      };
      
      // 서버에 POST 요청을 보냄
      fetch('/login/check', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(loginData)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('서버 응답 실패');
        }
        return response.json();
      })
      .then(mg_data => {
          if(mg_data.message === undefined){
            let redirectUrl
            let newUUID
            newUUID = mg_data[0].uuid;
            console.log(newUUID)
            setCookie('uuid', newUUID, { path: '/' });
            setConfirmMessage('로그인에 성공했습니다.');
            setShowMessage(true);

            redirectUrl = `/SelectPage`;
            window.location.href = redirectUrl;

          } else {
            setConfirmMessage(mg_data.message);
            setShowMessage(true);
          }
       })
      .catch(error => {
        console.error('오류 발생:', error);
        alert(error);
      }); 
    }

    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        onClickConfirmButton();
      }
    };

    return(
      <>
        <style dangerouslySetInnerHTML={{ __html: autofillStyles }} />
        <div style={styles.page}>
          <div style={styles.container}>
            <div style={styles.card}>
              <h2 style={styles.title}>Speed BOT 로그인</h2>
              <p style={styles.helper}>이메일과 비밀번호를 입력해 주세요.</p>

              <div style={styles.form}>
                <div style={styles.field}>
                  <span style={styles.label}>이메일 주소</span>
                  <div style={styles.inputWrap}>
                    <input 
                      type='text'
                      placeholder="test@gmail.com"
                      value={email}
                      onChange={handleEmail}
                      onKeyDown={handleKeyDown}
                      style={styles.input}
                      className="login-input"
                    />
                  </div>
                  {!emailValid && email.length > 0 && (
                    <div style={styles.error}>올바른 이메일을 입력해주세요.</div>
                  )}
                </div>

                <div style={styles.field}>
                  <span style={styles.label}>비밀번호</span>
                  <div style={styles.inputWrap}>
                    <input
                      type={showPassword ? "text" : "password"} // 비밀번호 표시 여부 토글
                      placeholder="영문(대문자 포함), 숫자, 특수문자 포함 8자 이상"
                      value={pw}
                      onChange={handlePw}
                      onKeyDown={handleKeyDown}
                      style={styles.input}
                      className="login-input"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      style={styles.toggleBtn}
                    >
                      {showPassword ? "Hide" : "Show"}
                    </button>
                  </div>
                  {!pwValid && pw.length > 0 && (
                    <div style={styles.error}>영문, 숫자, 특수문자 포함 8자 이상 입력해주세요.</div>
                  )}
                </div>

                <div style={styles.submitRow}>
                  <button 
                    onClick={onClickConfirmButton} 
                    disabled={notAllow} 
                    style={{
                      ...styles.submitBtn,
                      ...(notAllow ? styles.submitBtnDisabled : {}),
                    }}
                  >
                    확인
                  </button>
                </div>

                <div style={styles.linksRow}>
                  <Link to="/" style={styles.link}>메인 페이지</Link>
                  <Link to="/SignupAts" style={styles.link}>회원가입 페이지</Link>
                </div>
              </div>
            </div>
          </div>

          {showMessage && (
            <div style={styles.popup}>
              {confirmMessage}
            </div>
          )}
        </div>
      </>
    );
}